/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const StartHttpServer: BridgeCommands.Command<
    Types.Common.Httpserver.StartHttpServerParameters,
    any
    > = {
    legacyCommand: 'QUERY_HTTPSERVER_START',
    system: 'CrimsonNative',
    module: 'Httpserver',
    method: 'StartHttpServer',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const StopHttpServer: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_HTTPSERVER_STOP',
    system: 'CrimsonNative',
    module: 'Httpserver',
    method: 'StopHttpServer',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SendRedirectResponse: BridgeCommands.Command<
    Types.Common.Httpserver.SendRedirectResponseParameters,
    any
    > = {
    legacyCommand: 'QUERY_HTTPSERVER_REDIRECTRESPONSE',
    system: 'CrimsonNative',
    module: 'Httpserver',
    method: 'SendRedirectResponse',
    persistent: false
};

export const Httpserver = {
StartHttpServer,
StopHttpServer,
SendRedirectResponse
};
